import { useState, useEffect, useCallback } from 'react'
import getFaceProfile from '../../../services/advisors/getFaceProfile'
import base64url from 'base64url'
import '../../../common/bufferUtils'

const useFaceProfile = () => {
  const [advisorData, setAdvisorData] = useState(null)
  const [error, setError] = useState(null)
  const [firstName, setFirstName] = useState(null)

  const query = new URLSearchParams(window.location.search)
  let personalizationToken = query.get('PersonalizationToken')

  const fetchFaceProfile = useCallback(async id => {
    try {
      const advisorRes = await getFaceProfile({ id })
      if (!advisorRes.errors.length) {
        setAdvisorData(advisorRes.data)
      } else {
        setError('Error fetching face profile:', advisorRes.errors)
      }
    } catch (error) {
      setError('Error initializing client:', error)
    }
  }, [])

  useEffect(() => {
    if (personalizationToken) {
      const personalization = JSON.parse(base64url.decode(personalizationToken))
      if (personalization?.faceProfileId) {
        fetchFaceProfile(personalization.faceProfileId)
      }
      if (personalization?.clientfirstName) {
        setFirstName(personalization.clientfirstName.toLowerCase())
      }
    }
  }, [fetchFaceProfile, personalizationToken])

  return { advisorData, error, firstName }
}

export default useFaceProfile
